export const frontmatter = {
    "draft": true,
    "title": "Agents",
    "sidebar_group": "reference",
    "sidebar_label": "Agents",
    "sidebar_order": 7
}

export const toc = []